import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_TRADEPLUS_URL;

export const calculateDeliveryCost = async (payload) => {
  const { data } = await axios.post(
    `${API_BASE_URL}/Fulfillment/calculate-delivery-cost`,
    payload
  );
  return data;
};